/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/schools/', params);
}

function get(id, params) {
  return api.get(`/schools/${id}`, params);
}

function exportData(params) {
  return api.get('/schools/export', params);
}

function teachers(id, params) {
  return api.get(`/schools/${id}/teachers`, params);
}

function teachersExport(id, params) {
  return api.get(`/schools/${id}/teachers/export`, params);
}

function subjects(id, params) {
  return api.get(`/schools/${id}/subjects`, params);
}

function create(params) {
  return api.post('/schools', params);
}

function update(id, params) {
  return api.put(`/schools/${id}/update`, params);
}

function updateSheetOptions(id, params) {
  return api.put(`/schools/${id}/update-sheet-options`, params);
}

function getSheetOptions(id, params) {
  return api.get(`/schools/${id}/sheet-options`, params);
}

function generatePdf(id, params) {
  return api.post(`/schools/${id}/sheet`, params);
}

function remove(id, params) {
  return api.delete(`/schools/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

export const schoolsService = {
  index,
  teachers,
  get,
  create,
  update,
  remove,
  save,
  subjects,
  exportData,
  teachersExport,
  updateSheetOptions,
  getSheetOptions,
  generatePdf,
};
